
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import boosterHydrate from '../../../node_modules/nuxt-booster/runtime/hydrate.mjs'
export default Vue.extend({
  name: 'Campaign',
  components: {
    OrpModal: boosterHydrate(() => import('~/components/modals/OrpModal.vue')),
    ReportAd: boosterHydrate(() => import('~/components/modals/ReportAd.vue')),
    BoosterPicture: boosterHydrate(() => import('../../../node_modules/nuxt-booster/runtime/components/BoosterPicture.vue')),
    Button: boosterHydrate(() => import('primevue/button'))
  },
  data () {
    return {
      reportAd: false,
      meta: null,
      openOrpModal: false,
      cid: this.$route.query.id,
      $isEmptyObject: null,
      path: '',
      structuredData: {
        '@context': 'http://schema.org',
        '@type': 'JobPosting',
        name: 'test'
      },
      $sanitizeTitle: null,
      $gtm: null,
      verified: false,
      error: {},
      $config: null
    }
  },
  head() {
    const index = process.env.BUILD_ENV === 'production' && this.campaign.google && !this.campaign.deleted && this.campaign.slug === this.$route.params.slug && this.$sanitizeTitle(this.campaign?.city?.toLowerCase())?.split('|')?.includes(this.$sanitizeTitle(this.$route.params.city.toLowerCase())) && this.$dayjs(this.campaign.expire).format('YYYY-MM-DD HH:mm') >= this.$dayjs.utc().format('YYYY-MM-DD HH:mm')
    const city = this.campaign?.city?.toLowerCase().split('|').includes(this.$route?.params?.city?.toLowerCase().replace(/-/g, ' '))
      ? this.$route?.params?.city.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
      : ''
    const position = this.campaign?.title
    const title = this.$t('radar.metaTitle', { città: city, posizione: position }).toString()
    this.meta = title
    const localePaths = {
      en: '/en/job-offers/',
      fr: '/fr/offres-emploi/',
      es: '/es/ofertas-empleo/',
      pt: '/pt/ofertas-emprego/',
      de: '/de/job-angebote/',
      it: '/offerte-lavoro/'
    }

    const pathPrefix = localePaths[this.campaign.locale_identifier || 'it']
    const parameter = this.$i18n.locale === 'it' ? 2 : 3
    const tokens = this.$route.fullPath.split('/').slice(parameter)
    const result = tokens?.join('/')

    const stringa = `${pathPrefix}${result}`
    const canonical = `https://cving.com${stringa}${this.$route.query.verified === undefined ? '&verified=true' : ''}`

    const ogimage = this.campaign?.company?.cover_url || ''
    const metaDescription = this.$t('radar.metaDescription', { posizione: position, città: city, azienda: this.campaign?.company?.co_name }).toString()
    return {
      title,
      meta: [
        { property: 'og:title', content: title },
        { hid: 'og:description', property: 'og:description', name: 'og:description', content: metaDescription },
        { property: 'og:url', content: this.$router.currentRoute.fullPath },
        { hid: 'description', name: 'description', content: metaDescription },
        { hid: 'author', name: 'author', content: this.campaign?.company?.co_name },
        { hid: 'publisher', name: 'publisher', content: 'CVing' },
        { hid: 'ogimage', property: 'og:image', content: ogimage },
        { hid: 'robots', name: 'robots', content: index ? 'index,follow' : 'noindex,follow' },
        { hid: 'i18n-og-alt-de-DE', property: 'og:locale:alternate', content: null },
        { hid: 'i18n-og-alt-es-ES', property: 'og:locale:alternate', content: null },
        { hid: 'i18n-og-alt-en-US', property: 'og:locale:alternate', content: null },
        { hid: 'i18n-og-alt-it-IT', property: 'og:locale:alternate', content: null },
        { hid: 'i18n-og-alt-fr-FR', property: 'og:locale:alternate', content: null },
        { hid: 'i18n-og-alt-pt-BR', property: 'og:locale:alternate', content: null }
      ],
      link: [
        { hid: 'i18n-can', rel: 'canonical', content: canonical }
      ],
      script: this.campaign.verified && this.getStructuredData() ? [{ type: 'application/ld+json', json: this.getStructuredData() }] : []
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'site/isMobile'
    }),
    formattedTitle() {
      if (!this.campaign?.title) { return '' }
      return this.campaign.title
        .replace(/\s*\/\s*/g, ' / ')
    },
    getCities() {
      const cities = this.campaign.city
        ? this.campaign.city.split('|')
        : []

      if (cities.length > 1) {
        return cities.map((city, index) => {
          const isLastInGroup = (index + 1) % 4 === 0 && index + 1 !== cities.length
          return isLastInGroup ? `${city},\n` : city
        }).join(', ').replace(/,\n,/g, ',\n')
      }
      return ''
    },
    getTags() {
      let tags = []
      // Contratto
      if (Number(this.campaign.contract_type) !== 0 && this.campaign.contracttypestring && this.campaign.contracttypestring[0]) {
        tags.push(this.campaign.contracttypestring[0])
      }
      // RAL
      if (this.campaign.ral_max && this.campaign.ral_max > 0) {
        let salaryTag = this.campaign.ral_max + ' ' + this.campaign.currency
        if (this.campaign.salary_period) {
          salaryTag += ' / ' + this.$t('blocks.salaryPeriod.' + this.campaign.salary_period)
        }
        tags.push(salaryTag)
      }
      // Remote
      if (Number(this.campaign.id_correlation_remote_working) !== 0 && this.campaign.remoteworkingstring && this.campaign.remoteworkingstring[0]) {
        tags.push(this.campaign.remoteworkingstring[0])
      }
      // Sen
      if (Number(this.campaign.id_correlation_seniority) !== 0 && this.campaign.seniority) {
        tags.push(this.campaign.seniority[0])
      }
      // Istruzione
      if (Number(this.campaign.id_correlation_education_level) !== 0 && this.campaign.educationlevelstring) {
        tags.push(this.campaign.educationlevelstring[0])
      }
      // Lingue
      if (this.campaign.languages && this.campaign.languages.length > 0) {
        tags = [...tags, ...this.campaign.languages]
      }
      // Orari lavorativi
      if (Number(this.campaign.id_correlation_work_hour) !== 0 && this.campaign.workinghoursstring && this.campaign.workinghoursstring[0]) {
        tags.push(this.campaign.workinghoursstring[0])
      }
      // Benefits
      if (this.campaign.jobsbenefitsstring && this.campaign.jobsbenefitsstring.length > 0) {
        tags = [...tags, ...this.campaign.jobsbenefitsstring]
      }

      // Settore
      if (typeof this.campaign.macrocategory !== 'number' && this.campaign.macrocategory) {
        tags.push(this.campaign.macrocategory)
      } else if (typeof this.campaign.macrocategory === 'number' && this.campaign.macrocategory > 0) {
        tags.push(this.campaign.macrocategorystring)
      } else if (this.campaign.umanacategory1) {
        tags.push(this.campaign.umanacategory1)
      }

      return tags.map(tag => tag.charAt(0).toUpperCase() + tag.slice(1))
    },
    cities() {
      // Controlla se 'city' è una stringa e separa le città se contiene '|'
      return this.campaign.city
        ? this.campaign.city.split('|')
        : []
    },
    ...mapGetters({
      campaign: 'campaign/getCampaign',
      currentPage: 'radar/getCurrentPage',
      getSearchTitle: 'radar/getSearchTitle',
      getCity: 'radar/getCity',
      getRadius: 'radar/getRadius',
      googleKey: 'radar/getGoogleKey',
      orpSuggestion: 'radar/getOrpSuggestion'
    })
  },
  created() {
    if (this.$nuxt?.context?.from?.path) {
      const q = this.$nuxt?.context?.from?.query
      this.path = this.$nuxt.context.from.name.startsWith('radar-city')
        ? this.localePath({ name: 'radar-city', params: this.getCity || this.$nuxt.context.from.params.city, query: q })
        : this.localePath({ name: 'radar', query: q })
    } else {
      this.path = this.localePath({ name: 'radar', query: { p: '1', ea: '0', verified: 'true', orp: 'false', order: '1' } })
    }
  },
  mounted() {
    this.$gtm.push({
      event: 'view_job_application',
      event_data: {
        company_name: this.campaign?.company?.co_name,
        job_application_name: this.campaign?.title,
        job_application_place: this.campaign?.city,
        is_stage: this.campaign.contarct_type === 8,
        verified: true,
        orp_value: this.campaign.unlockamount,
        orp: this.campaign.p2p,
        page_url: this.$router.currentRoute.fullPath,
        page_title: this.meta
      }
    })
  },
  methods: {
    ...mapActions({
      setCampaign: 'campaign/setCampaign',
      setCurrentPage: 'radar/setCurrentPage',
      setSearchTitle: 'radar/setSearchTitle',
      setRadius: 'radar/setRadius',
      setOrpSuggestion: 'radar/setOrpSuggestion'
    }),
    getStructuredData () {
      const json = this.campaign
      if (json.cancelled || json.deleted || json.locations === '' || json.locations === null || !json.google || this.$dayjs(json.expire).format('YYYY-MM-DD HH:mm') < this.$dayjs.utc().format('YYYY-MM-DD HH:mm')) {
        return false
      } else {
        const obj = {
          '@context': 'https://schema.org',
          '@type': 'JobPosting'
        }

        if (json.ral_min && json.currency && json.ral_max) {
          obj.baseSalary = {
            '@type': 'MonetaryAmount',
            currency: json.currency,
            value: {
              '@type': 'QuantitativeValue',
              minValue: json.ral_min,
              maxValue: json.ral_max,
              unitText: json.salary_period || 'YEAR'
            }
          }
        }

        obj.directApply = true
        obj.title = json.title
        obj.description = json.description
        obj.datePosted = json.ts
        obj.validThrough = json.expire
        obj.hiringOrganization = {
          '@type': 'Organization',
          name: json?.company?.co_name,
          logo: json?.company?.logo_url
        }

        if (json.contract_type) {
          switch (json.contract_type) {
          case 1:
            obj.employmentType = 'OTHER'
            break
          case 2:
            obj.employmentType = 'TEMPORARY'
            break
          case 3:
            obj.employmentType = 'OTHER'
            break
          case 4:
            obj.employmentType = 'OTHER'
            break
          case 5:
            obj.employmentType = 'INTERN'
            break
          case 6:
            obj.employmentType = 'PART_TIME'
            break
          case 7:
            obj.employmentType = 'OTHER'
            break
          case 8:
            obj.employmentType = 'INTERN'
            break
          default:
            obj.employmentType = 'OTHER'
          }
        }

        if (json.locations === '{__Italia}') {
          obj.jobLocation = {
            '@type': 'Place',
            name: json.company.co_name,
            address: {
              '@type': 'PostalAddress',
              addressCountry: 'Italia'
            }
          }
        } else if (json.locations.length > 1) {
          let locs = []

          json.locations.forEach(function (c) {
            const locationItems = c.split('_')
            const temp = {
              '@type': 'Place',
              name: json.company.co_name,
              address: {
                '@type': 'PostalAddress',
                addressLocality: locationItems[0],
                addressRegion: locationItems[1],
                addressCountry: locationItems[2]
              },
              geo: {
                '@type': 'GeoCoordinates',
                latitude: locationItems[4],
                longitude: locationItems[5]
              }
            }
            locs = [
              ...locs,
              temp
            ]
          })

          obj.jobLocation = locs
        } else {
          const locationItems = json.locations[0].split('_')

          obj.jobLocation = {
            '@type': 'Place',
            name: json.company.co_name,
            address: {
              '@type': 'PostalAddress',
              addressLocality: locationItems[0],
              addressRegion: locationItems[1],
              addressCountry: locationItems[2]
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: locationItems[4],
              longitude: locationItems[5]
            }
          }
        }

        return obj
      }
    },
    getMedia(url, date) {
      if (!url) {
        return ''
      }
      const parts = url.split('/')
      const updatedUrl = parts.slice(4).join('/')
      return '/' + updatedUrl + '?updateTs=' + date
    },
    startJobApplication() {
      const total = (this.campaign?.custom_fields?.length > 0 ? 1 : 0) +
        Number(this.campaign?.form_id ? 1 : 0) +
        Number(this.campaign?.has_video ? 1 : 0) +
        1
      this.$gtm.push({
        event: 'job_application',
        event_data: {
          step_name: 'flusso_candidatura',
          step_stage: 'start',
          step_number: 0,
          total_steps: total,
          action_step: '',
          flow_origin: (this.campaign?.referer === '' || (this.campaign?.referer && this.campaign?.referer !== 'cving_radar')) ? 'landing' : 'radar',
          company_name: this.campaign?.company?.co_name,
          job_application_name: this.campaign?.title,
          job_application_place: this.campaign?.city,
          is_stage: this.campaign?.contract_type === 8,
          verified: this.campaign?.verified,
          orp: this.campaign.p2p,
          orp_value: Number(this.campaign.unlockamount),
          page_url: this.$router.currentRoute.fullPath,
          page_title: this.meta
        }
      })
      this.$router.push(this.localePath({ name: 'application-id-steps', params: { id: this.cid } }))
    }
  }
})
